import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";
import 'dayjs/locale/ko';
import moment from 'moment';
import { useEffect } from 'react';

const DatesPicker = props => {
    const { sx, daterange, setDateRange, ranges = "def", size="small" } = props

    const updateDates = (ranges) => {
        let start = new Date();
        let end = new Date();

        switch(ranges) {
            case "today":
                start = new Date();
                end = start;
                break;
            case "yesterday":
                start = new Date(moment().subtract(1, 'days'));
                end = start;
                break;
            case "thisweek":
                start = new Date(moment().startOf('week'));
                end = new Date(moment().endOf('week'));
                break;
            case "thismonth":
                start = new Date(moment().startOf('month'));
                end = new Date(moment().endOf('month'));
                break;
            case "lastweek":
                start = new Date(moment().subtract(1, 'weeks').startOf('week'));
                end = new Date(moment().subtract(1, 'weeks').endOf('week'));
                break;
            case "lastmonth":
                start = new Date(moment().subtract(1, 'months').startOf('month'));
                end = new Date(moment().subtract(1, 'months').endOf('month'));
                break;    
            default:
                start = new Date('2025-01-01');
                end = new Date();
                break;
        }

        setDateRange({
            startdate: start,
            enddate: end
        });
    }

    useEffect(() => {
        ranges && updateDates(ranges);
    }, [ranges])

    return (
        <Stack direction="row" spacing={2} sx={sx}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                <DatePicker
                    label={daterange.startname}
                    value={dayjs(daterange.startdate)} // Ensure the value is a dayjs object
                    onChange={(newValue) => {
                        setDateRange({
                            ...daterange,
                            startdate: newValue ? newValue.toDate() : null, // Convert dayjs to Date
                        });
                    }}
                    inputFormat="YYYY-MM-DD" // Correct input format
                    renderInput={(params) => <TextField {...params} size={size} sx={{ width: '160px' }} />}
                />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                <DatePicker                    
                    label={daterange.endname}
                    value={dayjs(daterange.enddate)}
                    onChange={(newValue) => {
                        setDateRange({
                            ...daterange, 
                            enddate: newValue ? newValue.toDate() : null,
                        });
                    }}
                    inputFormat="YYYY-MM-DD"
                    renderInput={(params) => <TextField {...params} size={size} sx={{ width: '160px' }} />}
                />
            </LocalizationProvider>
        </Stack>
    )
}

export default DatesPicker